import { render, staticRenderFns } from "./set-org.vue?vue&type=template&id=0f6df6f5&"
import script from "./set-org.vue?vue&type=script&lang=js&"
export * from "./set-org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports